const enhancePhoneModels = picker => {
  const radios = [...picker.querySelectorAll('input[type="radio"][data-option-name]')];
  const models = radios.filter(r => /iphone|samsung|galaxy/i.test(r.value));
  if (!models.length || new Set(models.map(r=>r.dataset.optionName)).size !== 1) return;
  const original = models[0].closest('fieldset');
  if (!original || models.some(r=>r.closest('fieldset')!==original)) return;
  if(picker.dataset.phoneSelection===undefined) {
    picker.dataset.phoneSelection=new URL(location.href).searchParams.has('variant')?(models.find(r=>r.checked)?.value||''):'';
  }
  let controls = picker.querySelector('[data-phone-model-controls]');
  if(!controls) {
    controls=document.createElement('div'); controls.dataset.phoneModelControls='';
    original.before(controls);
    for(const brand of ['iPhone','Samsung']) {
      const options=models.filter(r=>brand==='iPhone'?/iphone/i.test(r.value):/samsung|galaxy/i.test(r.value));
      if(!options.length)continue;
      const prompt=brand==='iPhone'?'Choose an iPhone model':'Choose a Samsung model';
      const label=document.createElement('label');label.textContent=prompt;
      const select=document.createElement('select');select.dataset.phoneBrand=brand;select.setAttribute('aria-label',prompt);
      const empty=document.createElement('option');empty.value='';empty.textContent=picker.dataset.phoneChoose;select.append(empty);
      options.forEach(r=>{const o=document.createElement('option');o.value=r.value;o.textContent=r.value;select.append(o)});
      label.append(select);controls.append(label);
      select.addEventListener('change',event=>{
        event.stopPropagation();
        picker.dataset.phoneSelection=select.value;
        if(!select.value) { enhancePhoneModels(picker);return; }
        const target=[...picker.querySelectorAll('input[type="radio"][data-option-name]')].find(r=>r.value===select.value&&r.dataset.optionName===models[0].dataset.optionName);
        if(target) {target.click(); controls.querySelectorAll('select').forEach(s=>{if(s!==select)s.value=''});}
      });
    }
  }
  original.hidden=true; original.dataset.phoneNativeModels='';
  const selected=picker.dataset.phoneSelection||'';
  controls.querySelectorAll('select').forEach(s=>{s.value=[...s.options].some(o=>o.value===selected)?selected:''});
  const scope=picker.closest('.product-details, .quick-add-modal, .shopify-section');
  const form=[...(scope?.querySelectorAll('product-form-component')||[])].find(component=>component.dataset.productId===picker.dataset.productId)?.querySelector('form');
  if(form) {
    let validity=controls.querySelector('[data-phone-model-validity]');
    if(!validity){validity=document.createElement('input');validity.type='text';validity.className='visually-hidden';validity.dataset.phoneModelValidity='';validity.setAttribute('aria-label','Choose your phone model');validity.tabIndex=-1;validity.required=true;validity.setAttribute('form',form.id);controls.append(validity);}
    validity.value=selected;
    validity.setCustomValidity(selected?'':'Choose an iPhone or Samsung model before adding this case to your cart.');
  }
};
const installPhoneModels=()=>document.querySelectorAll('variant-picker[data-phone-models]').forEach(picker=>{
  enhancePhoneModels(picker);
  if(picker.phoneModelObserver)return;
  picker.phoneModelObserver=new MutationObserver(()=>enhancePhoneModels(picker));
  picker.phoneModelObserver.observe(picker,{childList:true,subtree:true});
  picker.addEventListener('change',()=>queueMicrotask(()=>enhancePhoneModels(picker)));
  document.addEventListener('click',event=>{
    if(!picker.isConnected||picker.dataset.phoneSelection||!picker.querySelector('[data-phone-model-controls]'))return;
    const button=event.target.closest('add-to-cart-component button,button[name="add"],.sticky-add-to-cart__button');
    if(!button)return;
    const form=button.form||button.closest('product-form-component')?.querySelector('form');
    if(form?.closest('product-form-component')?.dataset.productId!==picker.dataset.productId)return;
    event.preventDefault();event.stopImmediatePropagation();
    const select=picker.querySelector('[data-phone-brand]');select?.focus();
    picker.querySelector('[data-phone-model-validity]')?.reportValidity();
  },true);
});
document.addEventListener('DOMContentLoaded',installPhoneModels);
document.addEventListener('shopify:section:load',installPhoneModels);
